import { request } from '../utils/request';

export type ResolveTenantDTO = {
	tenantId: string;
};

export const resolveTenant = (host?: string) => {
	return request<ResolveTenantDTO>({
		url: '/admin/tenant/resolve',
		method: 'get',
		params: host ? { host } : undefined,
		headers: { 'X-Skip-Token': '1', 'X-Skip-Tenant': '1' },
	});
};
